/* eslint-disable lit/attribute-value-entities */
import { AngularLayout, FlexLayout } from '@rhtml/modifiers';
import { Component, css, html, LitElement } from '@rxdi/lit-html';
import { Animation, Parallax, ScrollObserver } from '@shared/modifiers';
import { ReactivumTheme } from '@shared/styles/theme';
import completeProject from 'url:../../../assets/images/complete-project.svg';
import consultingImage from 'url:../../../assets/images/consulting.svg';
import frontendBackend from 'url:../../../assets/images/frontend-backend.svg';

/**
 * @customElement services-component
 */
@Component({
  selector: 'services-component',
  styles: [
    css`
      ${ReactivumTheme}

      :host {
        display: block;
        color: var(--text-primary);
      }

      .services-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
        gap: 32px;
        margin-top: 40px;
      }

      .service-button {
        display: inline-flex;
        align-items: center;
        padding: 12px 24px;
        background: var(--bg-secondary);
        border: 1px solid var(--border-light);
        border-radius: var(--radius-md);
        color: var(--primary-color);
        text-decoration: none;
        font-size: 0.9rem;
        font-weight: 500;
        transition: all 0.3s ease;
        cursor: pointer;
      }

      .service-button:hover {
        background: var(--primary-color);
        color: white;
        border-color: var(--primary-color);
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 102, 255, 0.3);
      }

      @media (max-width: 768px) {
        .services-grid {
          grid-template-columns: 1fr;
          gap: 24px;
        }
      }
    `,
  ],
  modifiers: [...FlexLayout, ...AngularLayout, Animation, ScrollObserver, Parallax],
  template() {
    return html`
      <section class="section" id="services" scroll-observer threshold="0.2">
        <div class="container">
          <h2 class="section-title" animated="fadeInDown" delay="0.2s">Our Services</h2>
          <p class="section-subtitle" animated="fadeInUp" delay="0.4s">
            We provide comprehensive web development solutions tailored to your specific needs, from complete project
            implementations to specialized consulting services.
          </p>

          <div class="services-grid">
            <!-- Complete Project Solutions -->
            <div class="card service-card" animated="slideInLeft" delay="0.1s" parallax speed="0.2" direction="up">
              <div class="service-illustration">
                <img src=${completeProject} alt="Complete Project Solutions" />
              </div>
              <h3 class="card-title">Complete Project Solutions</h3>
              <p class="card-description">
                Work with us to implement the best possible long-term working solution to given idea, because
                scalability, performance and sustainability should not be just fancy words.
              </p>
              <div class="service-button">Learn More →</div>
            </div>

            <!-- Frontend & Backend Development -->
            <div class="card service-card" animated="slideInUp" delay="0.1s" parallax speed="0.15" direction="up">
              <div class="service-illustration">
                <img src=${frontendBackend} alt="Frontend & Backend Development" />
              </div>
              <h3 class="card-title">Frontend & Backend Development</h3>
              <p class="card-description">
                Reactive Solutions delivers comprehensive frontend and backend development services, handling small to
                medium-sized projects with modern technologies and best practices.
              </p>
              <div class="service-button">Learn More →</div>
            </div>

            <!-- Web Development Consulting -->
            <div class="card service-card" animated="slideInRight" delay="0.1s" parallax speed="0.25" direction="up">
              <div class="service-illustration">
                <img src=${consultingImage} alt="Web Development Consulting" />
              </div>
              <h3 class="card-title">Web Development Consulting</h3>
              <p class="card-description">
                Optimize your web application's architecture, implementation, performance, memory usage and scaling
                capabilities with our expert advice and guidance.
              </p>
              <div class="service-button">Learn More →</div>
            </div>
          </div>
        </div>
      </section>
    `;
  },
})
export class ServicesComponent extends LitElement {}
